import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
  ValidationMessage,
} from '@modusign/design-system';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { PDFJS } from 'pdfjs-dist';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';

interface FileOpenPasswordPromptProps {
  passwordResponse: number;
  onPasswordVerify: (password: string) => void;
}
export default function FileOpenPasswordPrompt({
  passwordResponse,
  onPasswordVerify,
}: FileOpenPasswordPromptProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (passwordResponse === PDFJS.PasswordResponses.INCORRECT_PASSWORD) {
      setErrorMessage('비밀번호가 정확하지 않습니다. 다시 입력해 주세요.');
    } else if (passwordResponse === PDFJS.PasswordResponses.NEED_PASSWORD) {
      setErrorMessage('');
    }
  }, [passwordResponse]);

  const touchFormInput = () => {
    if (!isFormTouched) {
      setIsFormTouched(true);
    }
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim();
    let error = '';

    if (!value) {
      error = '비밀번호를 입력해 주세요.';
    }

    setErrorMessage(error);
    setPassword(value);
    touchFormInput();
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (password.length > 0) {
      onPasswordVerify(password);
    }
    touchFormInput();
  };

  return (
    <Box maxWidth="xs" mx="auto" p={4}>
      <Flex
        alignItems="center"
        as="form"
        bg="darkGray600"
        borderRadius="3px"
        flexDirection="column"
        justifyContent="center"
        px={9}
        py={8}
        onSubmit={handleSubmit}
      >
        <Heading as="h1" color="textNeutralLightest" fontSize="lg" fontWeight="bold">
          문서 비밀번호 입력
        </Heading>
        <Text color="textNeutralLightest" mt={4}>
          문서를 보려면 문서 비밀번호를 입력해 주세요.
        </Text>
        <Input
          isInvalid={isFormTouched && !!errorMessage}
          mt={7}
          name="password"
          placeholder="비밀번호"
          type="password"
          value={password}
          onBlur={touchFormInput}
          onChange={handleChange}
        />
        {isFormTouched && errorMessage && (
          <ValidationMessage sx={{ alignSelf: 'flex-start' }}>{errorMessage}</ValidationMessage>
        )}
        <Button disabled={!!errorMessage || !isFormTouched} mt={7} type="submit" variant="primary">
          확인
        </Button>
      </Flex>
    </Box>
  );
}
